import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { updateDeck } from '../store';
import { Dialog, Button } from '../design-system';
import './DeckConfigModal.css';

/**
 * DeckConfigModal - Modal for deck daily limits (no name/delete - those are in sidebar menu)
 */

// 表单按 open 会话挂载：以卡组当前配置初始化即可，不需要 effect 回写。
const DeckConfigForm = ({ deck, onClose }) => {
  const { t } = useTranslation('modals');
  const [newCardsPerDay, setNewCardsPerDay] = useState(deck.new_cards_per_day || 20);
  const [reviewCardsPerDay, setReviewCardsPerDay] = useState(deck.review_cards_per_day || 200);

  const handleSave = () => {
    updateDeck(deck.id, {
      new_cards_per_day: parseInt(newCardsPerDay) || 20,
      review_cards_per_day: parseInt(reviewCardsPerDay) || 200,
    });
    onClose();
  };

  return (
    <Dialog
      isOpen={true}
      onClose={onClose}
      title={t('deckConfig.title')}
      size="md"
      footer={
        <>
          <Button variant="neutral" onClick={onClose}>
            {t('common:cancel', 'Cancel')}
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {t('button.save')}
          </Button>
        </>
      }
    >
      <div className="deck-config-form">
        <label className="deck-config-label">{t('deckConfig.newCardsPerDay')}</label>
        <input
          type="number"
          className="deck-config-input"
          value={newCardsPerDay}
          onChange={(e) => setNewCardsPerDay(e.target.value)}
          min={0}
          max={999}
        />
        <p className="deck-config-hint">{t('deckConfig.newCardsHint')}</p>

        <label className="deck-config-label">{t('deckConfig.reviewCardsPerDay')}</label>
        <input
          type="number"
          className="deck-config-input"
          value={reviewCardsPerDay}
          onChange={(e) => setReviewCardsPerDay(e.target.value)}
          min={0}
          max={9999}
        />
        <p className="deck-config-hint">{t('deckConfig.reviewCardsHint')}</p>
      </div>
    </Dialog>
  );
};

const DeckConfigModal = ({ isOpen, onClose, deck }) => {
  // 关闭即卸载表单，下次打开以最新配置重新挂载。
  if (!isOpen || !deck) return null;
  return <DeckConfigForm key={deck.id} deck={deck} onClose={onClose} />;
};

export default DeckConfigModal;
